import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_ROUTE_NAME = Symbol('admin.affiliates.approved.trackers-settings.trackers');
export const ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_LIST_ROUTE_NAME = Symbol('admin.affiliates.approved.trackers-settings.trackers-list');
export const TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_TRACKERS = Symbol('admin.affiliates.approved.trackers-settings.trackers');

export const AFFILIATE_TRACKERS_SETTINGS_LIST_QUERY = 'affiliate.get-trackers-settings';
export const AFFILIATE_TRACKERS_SETTINGS_LIST_API_URL = 'admin/affiliates/:id/trackers/list';

export const AFFILIATE_CURRENT_TRACKER_QUERY = 'affiliate.show-current-tracker';
export const AFFILIATE_CURRENT_TRACKER_API_URL = 'admin/affiliates/:id/trackers/:trackerId/show_condition_data';

export const AFFILIATE_TRACKERS_SETTINGS_CREATE_EDIT_MUTATION = 'affiliate.create-edit-tracker';
export const AFFILIATE_TRACKERS_SETTINGS_CREATE_EDIT_API_URL = 'admin/affiliates/:id/trackers/:trackerId';

export const AFFILIATE_GET_TRACKER_COUNTRY_QUERY = 'affiliate.get-tracker-country';
export const AFFILIATE_GET_TRACKER_COUNTRY_API_URL = 'admin/affiliates/:id/trackers/:trackerId/show_country';

export const AFFILIATE_CHANGE_TRACKER_COUNTRY_MUTATION = 'affiliate.change-tracker-country';
export const AFFILIATE_CHANGE_TRACKER_COUNTRY_API_URL = 'admin/affiliates/:id/trackers/:trackerId/update_country';

export const AFFILIATE_MASS_CHANGE_TRACKER_COUNTRY_MUTATION = 'affiliate.mass-change-tracker-country';
export const AFFILIATE_MASS_CHANGE_TRACKER_COUNTRY_API_URL = 'admin/affiliates/:id/trackers/mass_update_country';

export const AFFILIATE_TRACKER_CONDITIONS_QUERY = 'affiliate.tracker-conditions';
export const AFFILIATE_TRACKER_CONDITIONS_API_URL = 'admin/affiliates/:id/trackers/conditions_list';

export const AFFILIATE_GET_DEPARTMENT_QUERY = 'affiliate.tracker.department.get';
export const AFFILIATE_GET_DEPARTMENT_API_URL = 'admin/affiliates/:id';

export const AFFILIATE_CHANGE_TRACKER_CONDITION_MUTATION = 'affiliate.change-tracker-condition';
export const AFFILIATE_CHANGE_TRACKER_CONDITION_API_URL = 'admin/affiliates/:id/trackers/update_trackers_by_condition';

export const AFFILIATE_CHANGE_TRACKER_FIXED_PAYMENTS_MUTATION = 'affiliate.change-tracker-fixed-payments';
export const AFFILIATE_CHANGE_TRACKER_FIXED_PAYMENTS_API_URL = 'admin/affiliates/:id/trackers/update_trackers_by_fixed_payment';

export const AFFILIATE_TRACKER_TRAFFIC_SOURCE_LIST_QUERY = 'affiliate.tracker.traffic_source.list';
export const AFFILIATE_TRACKER_TRAFFIC_SOURCE_LIST_API_URL = 'admin/affiliates/:id/trackers/list_of_traffic_sources';

export const AFFILIATE_BULK_CHANGE_TRACKER_TRAFFIC_SOURCE_MUTATION = 'affiliate.bulk-change-tracker-traffic-source';
export const AFFILIATE_BULK_CHANGE_TRACKER_TRAFFIC_SOURCE_API_URL = 'admin/affiliates/:id/trackers/mass_update_traffic_sources';

export const AFFILIATE_CHANGE_TRACKER_TRAFFIC_SOURCE_MUTATION = 'affiliate.change-tracker-traffic-source';
export const AFFILIATE_CHANGE_TRACKER_TRAFFIC_SOURCE_API_URL = 'admin/affiliates/:id/trackers/:trackerId/update_traffic_source';

export const AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS = {
  HISTORY_CHANGES_EDIT: new Permission(
    PermissionsList.admin.HISTORYOFTRACKERSCHANGES_EDIT,
  ),
  HISTORY_CHANGES_DELETE: new Permission(
    PermissionsList.admin.HISTORYOFTRACKERSCHANGES_DELETE,
  ),
  CHANGE_TRAFFIC_SOURCE: new Permission(
    PermissionsList.admin.AFFILIATES_CHANGE_TRAFFIC_SOURCE,
  ),
  UPDATE_COUNTRY: new Permission(
    PermissionsList.admin.AFFILIATES_UPDATE_COUNTRY,
  ),
};
